import React from 'react'
import styled, { css } from 'styled-components'

export const BackdropWrapper = styled.div`
  width: 30px;
  ${({ size }) => {
    if (size === 'small') {
      return css`
        height: 24px;
      `
    }
    return css`
      height: 40px;
    `
  }};
  display: flex;
  justify-content: center;
  place-items: center;
  padding: 8px;
  background-color: rgba(24, 26, 28, 0.5);
  border-radius: 4px;
  cursor: pointer;

  svg path {
    fill: #E7E7E7;
  }

  &:hover {
    svg path {
      fill: #fff;
    }
  }

  @media (max-width: 940px) {
    visibility: hidden;
  }
`

export const MoveIcon = ({ onClick, size, color, ...rest }: any) => (
  <BackdropWrapper onClick={onClick} size={size} {...rest}>
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7 4C8.10457 4 9 3.10457 9 2C9 0.895431 8.10457 0 7 0C5.89543 0 5 0.895431 5 2C5 3.10457 5.89543 4 7 4ZM17 4C18.1046 4 19 3.10457 19 2C19 0.895431 18.1046 0 17 0C15.8954 0 15 0.895431 15 2C15 3.10457 15.8954 4 17 4ZM17 14C18.1046 14 19 13.1046 19 12C19 10.8954 18.1046 10 17 10C15.8954 10 15 10.8954 15 12C15 13.1046 15.8954 14 17 14ZM19 22C19 23.1046 18.1046 24 17 24C15.8954 24 15 23.1046 15 22C15 20.8954 15.8954 20 17 20C18.1046 20 19 20.8954 19 22ZM9 12C9 13.1046 8.10457 14 7 14C5.89543 14 5 13.1046 5 12C5 10.8954 5.89543 10 7 10C8.10457 10 9 10.8954 9 12ZM7 24C8.10457 24 9 23.1046 9 22C9 20.8954 8.10457 20 7 20C5.89543 20 5 20.8954 5 22C5 23.1046 5.89543 24 7 24Z'
        fill={color}
      />
    </svg>
  </BackdropWrapper>
)
import React from 'react'
import styled, { css } from 'styled-components'

export const BackdropWrapper = styled.div`
  width: 30px;
  ${({ size }) => {
    if (size === 'small') {
      return css`
        height: 24px;
      `
    }
    return css`
      height: 40px;
    `
  }};
  display: flex;
  justify-content: center;
  place-items: center;
  padding: 8px;
  background-color: rgba(24, 26, 28, 0.5);
  border-radius: 4px;
  cursor: pointer;

  svg path {
    fill: #E7E7E7;
  }

  &:hover {
    svg path {
      fill: #fff;
    }
  }

  @media (max-width: 940px) {
    visibility: hidden;
  }
`

export const MoveIcon = ({ onClick, size, color, ...rest }: any) => (
  <BackdropWrapper onClick={onClick} size={size} {...rest}>
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7 4C8.10457 4 9 3.10457 9 2C9 0.895431 8.10457 0 7 0C5.89543 0 5 0.895431 5 2C5 3.10457 5.89543 4 7 4ZM17 4C18.1046 4 19 3.10457 19 2C19 0.895431 18.1046 0 17 0C15.8954 0 15 0.895431 15 2C15 3.10457 15.8954 4 17 4ZM17 14C18.1046 14 19 13.1046 19 12C19 10.8954 18.1046 10 17 10C15.8954 10 15 10.8954 15 12C15 13.1046 15.8954 14 17 14ZM19 22C19 23.1046 18.1046 24 17 24C15.8954 24 15 23.1046 15 22C15 20.8954 15.8954 20 17 20C18.1046 20 19 20.8954 19 22ZM9 12C9 13.1046 8.10457 14 7 14C5.89543 14 5 13.1046 5 12C5 10.8954 5.89543 10 7 10C8.10457 10 9 10.8954 9 12ZM7 24C8.10457 24 9 23.1046 9 22C9 20.8954 8.10457 20 7 20C5.89543 20 5 20.8954 5 22C5 23.1046 5.89543 24 7 24Z'
        fill={color}
      />
    </svg>
  </BackdropWrapper>
)
